import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { AssetsService, IconName } from '@sc/data-access-assets';
import { ConfigurationService } from '@sc/data-access-configuration';
import { GeoCoordinates } from '@sc/data-access-models';
import { IconComponent } from '@sc/ui-components';
import { BaseGMapOverlay } from '../../../../utils/base-gmap-overlay';

@Component({
  selector: 'sc-gmap-fitters-mark',
  styleUrls: ['./gmap-fitters-mark.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconComponent],
  template: `
    <div class="icon-container" *ngIf="displayDot()">
      <sc-icon class="fitter-map" [name]="fitterIcon"></sc-icon>
    </div>
    <span class="custom-dot-image" *ngIf="!displayDot()" aria-hidden="true">
      <img [src]="getImageSrc()" alt="custom actual position logo" />
    </span>
  `,
})
export class GmapFittersMarkComponent
  extends BaseGMapOverlay
  implements OnChanges, OnDestroy
{
  @Input() public map: google.maps.Map;
  @Input() public fitterIcon: IconName;
  @Input() public set location(newLoc: GeoCoordinates) {
    this.position = newLoc;
  }

  constructor(
    elRef: ElementRef,
    private readonly configurationService: ConfigurationService,
    private readonly assetsService: AssetsService
  ) {
    super(elRef, 'gmap-fitters-mark');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.map?.previousValue && !!changes.map?.currentValue) {
      this.gmap = changes.map.currentValue;
    }
  }

  ngOnDestroy(): void {
    this.onRemove();
  }

  displayDot() {
    return !(
      (this.isDotImage() && this.fitterIcon === 'fitter') ||
      (this.isMarkImage() && this.fitterIcon === 'map_location')
    );
  }

  isMarkImage() {
    return !!this.configurationService.getConfig()?.map?.markIcon;
  }

  isDotImage() {
    return !!this.configurationService.getConfig()?.map?.dotIcon;
  }

  getImageSrc() {
    const config = this.configurationService.getConfig();
    const iconName =
      this.fitterIcon === 'fitter' ? config.map.dotIcon : config.map.markIcon;
    const logoPath = this.assetsService.getAssetPath(
      `${config.id}_${iconName}.svg`
    );

    return logoPath;
  }
}
